import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "digital-clock-container"
}
const _hoisted_2 = {
  class: "time-section",
  style: {"height":"100%"}
}
const _hoisted_3 = { href: "#" }
const _hoisted_4 = { class: "up" }
const _hoisted_5 = { class: "inn" }
const _hoisted_6 = { class: "down" }
const _hoisted_7 = { class: "inn" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = { class: "up" }
const _hoisted_10 = { class: "inn" }
const _hoisted_11 = { class: "down" }
const _hoisted_12 = { class: "inn" }
const _hoisted_13 = { class: "dots-separator" }
const _hoisted_14 = {
  key: 0,
  class: "dot"
}
const _hoisted_15 = {
  key: 1,
  class: "dot"
}
const _hoisted_16 = {
  class: "time-section",
  style: {"height":"100%"}
}
const _hoisted_17 = { href: "#" }
const _hoisted_18 = { class: "up" }
const _hoisted_19 = { class: "inn" }
const _hoisted_20 = { class: "down" }
const _hoisted_21 = { class: "inn" }
const _hoisted_22 = { href: "#" }
const _hoisted_23 = { class: "up" }
const _hoisted_24 = { class: "inn" }
const _hoisted_25 = { class: "down" }
const _hoisted_26 = { class: "inn" }
const _hoisted_27 = {
  key: 0,
  class: "dots-separator"
}
const _hoisted_28 = {
  key: 0,
  class: "dot"
}
const _hoisted_29 = {
  key: 1,
  class: "dot"
}
const _hoisted_30 = {
  key: 1,
  class: "time-section",
  style: {"height":"100%"}
}
const _hoisted_31 = { href: "#" }
const _hoisted_32 = { class: "up" }
const _hoisted_33 = { class: "inn" }
const _hoisted_34 = { class: "down" }
const _hoisted_35 = { class: "inn" }
const _hoisted_36 = { href: "#" }
const _hoisted_37 = { class: "up" }
const _hoisted_38 = { class: "inn" }
const _hoisted_39 = { class: "down" }
const _hoisted_40 = { class: "inn" }
const _hoisted_41 = {
  key: 2,
  class: "period"
}

import { ref, onMounted, computed, onBeforeUnmount, watch } from "vue";
import moment from 'moment';
import { displayService } from '@/_services';


const __default__ = {
  name: "ClckWidget",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    timeFormat: {},
    showSeconds: { type: Boolean },
    fontFamily: {},
    fontSize: {},
    fontColor: {},
    fontWeight: {},
    template: {},
    backgroundColor: {},
    seperatorColor: {},
    showSeperator: { type: Boolean },
    config: {},
    timeZone: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "e13b8c6e": (_ctx.seperatorColor),
  "b4549ac2": (boxShadowColor.value),
  "613350ad": (_ctx.fontColor),
  "a2af5724": (_ctx.backgroundColor)
}))

const props = __props;

const scaledFontSize = computed(() => {
  if (!props.fontSize) return 40;
  return Math.round(props.fontSize);
});

const currentTime = ref(new Date());
const clockTimer = ref<number | null>(null);
const timezoneOffset = ref<number | null>(null); // Store the timezone offset in milliseconds

const previousTime = ref({
  hours: [0, 0],
  minutes: [0, 0],
  seconds: [0, 0],
});

const formattedTime = computed(() => {
  const hours = currentTime.value.getHours();
  const minutes = currentTime.value.getMinutes();
  const seconds = currentTime.value.getSeconds();

  let formattedHours = hours;
  let hourString = "";

  if (props.timeFormat === "12h") {
    formattedHours = hours % 12;
    formattedHours = formattedHours || 12;
    hourString = formattedHours.toString();
  } else {
    hourString = formattedHours.toString().padStart(2, "0");
  }

  const formattedMinutes = minutes.toString().padStart(2, "0");
  let timeString = `${hourString}:${formattedMinutes}`;

  if (props.showSeconds) {
    const formattedSeconds = seconds.toString().padStart(2, "0");
    timeString += `:${formattedSeconds}`;
  }

  if (props.timeFormat === "12h") {
    timeString += hours >= 12 ? " PM" : " AM";
  }

  return timeString;
});

const digitalTime = computed(() => {
  const hours = currentTime.value.getHours();
  const minutes = currentTime.value.getMinutes();
  const seconds = currentTime.value.getSeconds();

  let formattedHours = hours;
  if (props.timeFormat === "12h") {
    formattedHours = hours % 12;
    formattedHours = formattedHours || 12; // 0 as 12
  }

  const hourString = formattedHours.toString().padStart(2, "0");
  const minuteString = minutes.toString().padStart(2, "0");
  const secondString = seconds.toString().padStart(2, "0");

  return {
    hours: [parseInt(hourString[0]), parseInt(hourString[1])],
    minutes: [parseInt(minuteString[0]), parseInt(minuteString[1])],
    seconds: [parseInt(secondString[0]), parseInt(secondString[1])],
    period: props.timeFormat === "12h" ? (hours >= 12 ? "PM" : "AM") : "",
  };
});

const getDateTimeZone = async () => {
  try {
    const formData = new FormData();
    formData.append("time_zone", props.timeZone);
    const response = await displayService.getDateTime(formData);
    const apiDateTime = response.dateTime; // "2025-07-09 15:14:39"
    
    // Parse the API date time
    const apiDate = moment(apiDateTime, 'YYYY-MM-DD HH:mm:ss');
    const localDate = moment(); // Current local time
    
    // Calculate the offset between API time and local time
    // This offset will be used to maintain the correct timezone time
    timezoneOffset.value = apiDate.valueOf() - localDate.valueOf();
    
    // Set the current time to the timezone time
    currentTime.value = apiDate.toDate();
    
    console.log('Clock - Timezone offset calculated:', timezoneOffset.value, 'ms');
    console.log('Clock - API time:', apiDateTime);
    console.log('Clock - Local time:', localDate.format('YYYY-MM-DD HH:mm:ss'));
    
  } catch (e) {
    console.log("error getting dateTimezone for clock", e);
    // Fallback to local time if API fails
    timezoneOffset.value = null;
    currentTime.value = new Date();
  }
};

function triggerFlipAnimation(digitType: string, position: number) {
  const element: any = document.querySelector(`.flip-${digitType}-${position}`);
  if (element) {
    element.classList.remove("play");
    void element.offsetWidth;
    element.classList.add("play");
  }
}

watch(
  digitalTime,
  (newTime, oldTime) => {
    if (oldTime) {
      if (newTime.hours[0] !== oldTime.hours[0]) {
        triggerFlipAnimation("hours", 0);
      }
      if (newTime.hours[1] !== oldTime.hours[1]) {
        triggerFlipAnimation("hours", 1);
      }
      if (newTime.minutes[0] !== oldTime.minutes[0]) {
        triggerFlipAnimation("minutes", 0);
      }
      if (newTime.minutes[1] !== oldTime.minutes[1]) {
        triggerFlipAnimation("minutes", 1);
      }
      if (props.showSeconds) {
        if (newTime.seconds[0] !== oldTime.seconds[0]) {
          triggerFlipAnimation("seconds", 0);
        }
        if (newTime.seconds[1] !== oldTime.seconds[1]) {
          triggerFlipAnimation("seconds", 1);
        }
      }
    }
  },
  { deep: true }
);

//ul style
const height = computed(() => props.config.height || 100);
const width = computed(() => props.config.width || 100);
const flipHeight = computed(() => Math.floor(height.value));
const flipWidth = computed(() => Math.floor(width.value * 0.23));
// const clockFontSize = computed(() => Math.floor(height.value * 0.95));
const clockFontSize = computed(() => {
  if (props.fontSize == 0 || !props.fontSize)
    return Math.floor(height.value * 0.75);
  return props.fontSize;
});

onMounted(async () => {
  // Only call API if timeZone is provided and not empty
  if (props.timeZone && props.timeZone.trim() !== '') {
    await getDateTimeZone();
  } else {
    // Use local time if no timezone specified or empty string
    timezoneOffset.value = null;
    currentTime.value = new Date();
  }
  
  previousTime.value = { ...digitalTime.value };

  const interval = props.showSeconds ? 1000 : 60000;
  clockTimer.value = window.setInterval(updateTime, interval);
});

onBeforeUnmount(() => {
  if (clockTimer.value) {
    window.clearInterval(clockTimer.value);
  }
});

function updateTime() {
  if (timezoneOffset.value !== null) {
    // Apply the timezone offset to maintain the correct timezone time
    const localTime = new Date();
    const timezoneTime = new Date(localTime.getTime() + timezoneOffset.value);
    currentTime.value = timezoneTime;
  } else {
    // Use local time if no timezone offset
    currentTime.value = new Date();
  }
}

function getDigitRange(digitType: string, position: number) {
  if (digitType === "hours" && position === 0) {
    return props.timeFormat === "12h" ? [0, 1] : [0, 1, 2];
  } else if (
    (digitType === "minutes" && position === 0) ||
    (digitType === "seconds" && position === 0)
  ) {
    return [0, 1, 2, 3, 4, 5];
  }
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
}

function getPreviousDigit(current: number, max: number) {
  return current === 0 ? max - 1 : current - 1;
}

function hexToRgba(hex: string, alpha: number) {
  let c = hex.replace("#", "");
  if (c.length === 3)
    c = c
      .split("")
      .map((x) => x + x)
      .join("");
  const num = parseInt(c, 16);
  return `rgba(${(num >> 16) & 255}, ${(num >> 8) & 255}, ${
    num & 255
  }, ${alpha})`;
}

const boxShadowColor = computed(() => hexToRgba(props.backgroundColor, 0.7));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.template == 'default')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "clock-widget",
          style: _normalizeStyle({
        fontFamily: _ctx.fontFamily,
        fontSize: `${scaledFontSize.value}px`,
        color: _ctx.fontColor,
        fontWeight: _ctx.fontWeight === 'bold' ? 'bold' : 'normal',
        fontStyle: _ctx.fontWeight === 'italic' ? 'italic' : 'normal',
        textDecoration: _ctx.fontWeight === 'underline' ? 'underline' : 'none',
      })
        }, _toDisplayString(formattedTime.value), 5))
      : _createCommentVNode("", true),
    (_ctx.template == 'digital')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "clock-inner",
            style: _normalizeStyle({
          maxWidth: '100%',
          maxHeight: '100%',
          width: '100%',
          height: '100%',
          aspectRatio: (props.showSeconds ? 6 : 4) + ' / 1',
          margin: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("ul", {
                class: "flip flip-hours-0",
                style: _normalizeStyle({
              height: '100%',
              aspectRatio: '2/3',
              fontSize: clockFontSize.value + 'px',
              boxShadow: `0 2px 5px ${boxShadowColor.value}`,
            })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitRange('hours', 0), (digit) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `h0-${digit}`,
                    class: _normalizeClass({
                active: digit === digitalTime.value.hours[0],
                before:
                  digit ===
                  getPreviousDigit(
                    digitalTime.value.hours[0],
                    props.timeFormat === '12h' ? 2 : 3
                  ),
              })
                  }, [
                    _createElementVNode("a", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(digit), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(digit), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ], 4),
              _createElementVNode("ul", {
                class: "flip flip-hours-1",
                style: _normalizeStyle({
              height: '100%',
              aspectRatio: '2/3',
              fontSize: clockFontSize.value + 'px',
              boxShadow: `0 2px 5px ${boxShadowColor.value}`,
            })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitRange('hours', 1), (digit) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `h1-${digit}`,
                    class: _normalizeClass({
                active: digit === digitalTime.value.hours[1],
                before: digit === getPreviousDigit(digitalTime.value.hours[1], 10),
              })
                  }, [
                    _createElementVNode("a", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(digit), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(digit), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.showSeperator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true),
              (_ctx.showSeperator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("ul", {
                class: "flip flip-minutes-0",
                style: _normalizeStyle({
              height: '100%',
              aspectRatio: '2/3',
              fontSize: clockFontSize.value + 'px',
              boxShadow: `0 2px 5px ${boxShadowColor.value}`,
            })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitRange('minutes', 0), (digit) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `m0-${digit}`,
                    class: _normalizeClass({
                active: digit === digitalTime.value.minutes[0],
                before: digit === getPreviousDigit(digitalTime.value.minutes[0], 6),
              })
                  }, [
                    _createElementVNode("a", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(digit), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(digit), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ], 4),
              _createElementVNode("ul", {
                class: "flip flip-minutes-1",
                style: _normalizeStyle({
              height: '100%',
              aspectRatio: '2/3',
              fontSize: clockFontSize.value + 'px',
              boxShadow: `0 2px 5px ${boxShadowColor.value}`,
            })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitRange('minutes', 1), (digit) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `m1-${digit}`,
                    class: _normalizeClass({
                active: digit === digitalTime.value.minutes[1],
                before: digit === getPreviousDigit(digitalTime.value.minutes[1], 10),
              })
                  }, [
                    _createElementVNode("a", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(digit), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(digit), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ], 4)
            ]),
            (_ctx.showSeconds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_ctx.showSeperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                    : _createCommentVNode("", true),
                  (_ctx.showSeperator)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showSeconds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("ul", {
                    class: "flip flip-seconds-0",
                    style: _normalizeStyle({
                height: '100%',
                aspectRatio: '2/3',
                fontSize: clockFontSize.value + 'px',
                boxShadow: `0 2px 5px ${boxShadowColor.value}`,
              })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitRange('seconds', 0), (digit) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `s0-${digit}`,
                        class: _normalizeClass({
                  active: digit === digitalTime.value.seconds[0],
                  before: digit === getPreviousDigit(digitalTime.value.seconds[0], 6),
                })
                      }, [
                        _createElementVNode("a", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                            _createElementVNode("div", _hoisted_33, _toDisplayString(digit), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(digit), 1)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ], 4),
                  _createElementVNode("ul", {
                    class: "flip flip-seconds-1",
                    style: _normalizeStyle({
                height: '100%',
                aspectRatio: '2/3',
                fontSize: clockFontSize.value + 'px',
                boxShadow: `0 2px 5px ${boxShadowColor.value}`,
              })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDigitRange('seconds', 1), (digit) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `s1-${digit}`,
                        class: _normalizeClass({
                  active: digit === digitalTime.value.seconds[1],
                  before:
                    digit === getPreviousDigit(digitalTime.value.seconds[1], 10),
                })
                      }, [
                        _createElementVNode("a", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(digit), 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(digit), 1)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ], 4)
                ]))
              : _createCommentVNode("", true),
            (_ctx.timeFormat === '12h')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(digitalTime.value.period), 1))
              : _createCommentVNode("", true)
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})